import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { TaskInput } from '../../types'
import {
  CustomerLogo,
  Primary12Regular,
  Primary12SemiBold,
  IconEyeOpen,
  Box
} from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/index'

export const ContractReviewListItemContent = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, statusIcon, preload } =
    useManualTaskListItemContentToolkit<TaskInput>({
      taskId
    })

  if (!manualTask?.input) {
    return <InboxListItemContent.Loading />
  }

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      onPreload={preload}
      title={
        <Box
          width="100%"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >{`${manualTask?.input.contract?.name ?? 'Uploaded contract'} ${manualTask?.input.customer?.legalName && ` for ${manualTask?.input.customer?.legalName}`}`}</Box>
      }
      description={
        <>
          Contract sent for approval by{' '}
          <Box as="span" {...Primary12SemiBold}>
            Contract intake agent
          </Box>
        </>
      }
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <CustomerLogo
            src={
              manualTask.input.customer
                ? getLogoSrc(manualTask.input.customer)
                : undefined
            }
            size={24}
            fallbackSize={16}
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
